<div class="container d-flex flex-column align-items-center access-denied">
  <h2 class="title-text">{{ 'messages.accessErrorTitle' | translate }}!</h2>

  <div class="my-3 font-15">{{ 'messages.accessErrorDescription' | translate }}</div>

  <button class="mt-3" mat-raised-button (click)="onBackToDashboard()">
    Back to dashboard
  </button>
</div>
